// extracted by mini-css-extract-plugin
module.exports = {"loader":"GridLoader_loader__3_CYM"};